import "./vendorSearch.css";
import jsonData from "../../config/VendorSearchFormFields.json";
import { useEffect, useState, useContext } from "react";
import { useHistory } from "react-router-dom";
import ProgressBar from "../progress/progressBar";
import ErrorPage from "../error-page/error";
import { Accordion, AccordionSummary, AccordionDetails, TablePagination, IconButton, Tooltip, Dialog, DialogTitle, DialogContent, DialogActions, Typography, Button, Avatar, Alert, Switch } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Link } from "react-router-dom";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import IqviaAccordianData from "../../config/VendorAccordianDataConfig.json";
import api from "../../service/api";
import { useLocation } from "react-router-dom";
import FileDownloadIcon from "@mui/icons-material/Download";
import Backdrop from "@mui/material/Backdrop";
import InputDetail from "../detail-page/input/detail-input-vendorSearch";
import Storage from "../../session/storage";
import filter from "../../service/filter";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import Stack from "@mui/material/Stack";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import payloadCountry from "../../config/vendorPicklistApiPayload.json";
import popUpMessages from "../../config/popUpMsg.json";
import ProfileIcon from "../shared/ProfileIcon";
import { DirectionContext } from "../../context/DirectionProvider";
import { formatPopupMessage } from "../shared/util";
import IqviaHcoResponse from "./IqviaHcoResponse";
import { Done, ContentCopy } from "@mui/icons-material";
import useLocalStorage from "../../hooks/useLocalStorage";
import {DropdownContext}  from '../../context/DropDownContext';


const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(0),
  },
  nested: {
    paddingLeft: theme.spacing(1),
  },
}));

const IqviaSearch = (props) => {
  const direction = useContext(DirectionContext);
  const location = useLocation();
  const classes = useStyles();
  const [isCopied, setIsCopied] = useState(null)

  // const vendor = location?.state?.vendor.toLowerCase();
  const [vendor, setVendor] = useState(location?.state?.vendor)
  const [iqviadata] = useState(jsonData);
  var getdata = iqviadata?.countries.find((res) => {
    if (res?.country_Name == location?.state?.seletedCountry) {
      return res?.country_Name === location?.state?.seletedCountry;
    } 
    return res?.country_Name == "default";
  });
  const [countrydata] = useState(getdata);
  const [AccordianData] = useState(IqviaAccordianData);
  var getAccordianData = AccordianData.countries.find((res) => {
    if (res?.country_Name == location?.state?.seletedCountry) {
      return res?.country_Name === location?.state?.seletedCountry;
    }  
    return res?.country_Name == "default";
  });
  const [IqviaCountryData] = useState(getAccordianData);
  var getPaylodCountry = payloadCountry.countries.find((res) => {
    if (res?.country_Name == location?.state?.seletedCountry) {
      return true;
    }
    return res?.country_Name == "default";
  });    
  const [popMsg] = useState(popUpMessages?.vendorSearch);
  const history = useHistory();
  const [rowsPerPage, setRowPerPage] = useState(10);
  const [entity, setEntity] = useState();
  const [loading, setLoading] = useState(false);
  const [errorAlert, setErrorAlert] = useState(false);
  const [errorMsg, setErrorMsg] = useState();
  const [searchData, setsearchData] = useState([]);
  const [showPopUp, setShowPopUp] = useState(false);
  const [responseData, setResponseData] = useState([]);
  const [Page, setPage] = useState(0);
  const [noRecords, setNoRecords] = useState(false);
  const [sessionAllItems, setsessionAllItems] = useState([]);
  const [expanded, setExpanded] = useState([]);
  const [popUpMessage, setPopUpMessage] = useState({ heading: "", message: "" });
  const [subscribeData, setSubscribeData] = useState({});
  const [open, setOpen] = useState(false);
  const [clear, setClear] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [hcoSearch, setHcoSearch] = useState(false)
  const { setDropdownValue } = useContext(DropdownContext)
  let rowsArray = [];

  const source = location.state.seletedCountry === "United States"
    ? (hcoSearch ? "IQVIA_US" : "VNDR-VN")
    : "VNDR-CGDM";

  const [langLocaleChange] = useLocalStorage('wglang_api')

  useEffect(() => {
    if( (location?.state?.vendor == undefined && location?.state?.seletedCountry == undefined )|| (location?.state?.vendor == null && location?.state?.seletedCountry == null)){
      props.history.push('/')
  } 
  else{
  
    setLoading(true);
    api
      .getPickList(getPaylodCountry?.key?.payloadKey, source, undefined, undefined, undefined, langLocaleChange)
      .then((res) => {
        if(getPaylodCountry?.key?.payloadKey == 'United States'){
            Storage.setLovBoundedList(filter.mapVnPickList(res.data[0]))
            setDropdownValue(filter.mapVnPickList(res.data[0]))
          }else{
            Storage.setLovBoundedList(filter.mapPickList(res.data[0]))
            setDropdownValue( filter.mapPickList(res.data[0]))
          }
        let intervalId = setTimeout(() => {
          setLoading(false);
          setShowForm(true);
          clearTimeout(intervalId);
        }, 4000);
      })
      .catch((error) => {
        let errorDetail = error;
        let msg = errorDetail.response ? errorDetail.response.data.errorCode : popMsg[0].failure.description;
        setErrorMsg(msg ? msg : popMsg[0].failure.description);
        setErrorAlert(true);
        setLoading(false);
      });
    }
  }, [langLocaleChange]);

  const handleClick = (panel) => {
    if (expanded[panel]) {
      setExpanded({
        ...expanded,
        [panel]: false,
      });
    } else {
      setExpanded({
        ...expanded,
        [panel]: true,
      });
    }
  };

  /**
   * Handle Accordian change
   * @param {*} id
   */
  const handleChange = (panel) => (event, isExpanded) => {
    // setExpanded(isExpanded ? panel : false);
    setExpanded({
      ...expanded,
      [panel]: isExpanded,
    });
  };

  const subcribeProfile = (rowdata, event) => {
    event.stopPropagation();
    setPopUpMessage({
      heading: popMsg[0].subscribeConfirmation.heading,
      message: popMsg[0].subscribeConfirmation.description,
      cancel: "Cancel",
      onOk: "Confirm",
    });
    setShowPopUp(true);
    setSubscribeData({
      vendor: vendor,
      onekeyEid: rowdata.individual.individualEid,
      entityType: rowdata.entityType,
      country: rowdata.country ?? location.state.seletedCountry,
      firstName: rowdata.individual.firstName,
      lastName: rowdata.individual.lastName, 
      record: { "individual": rowdata.individual, "workplace": rowdata.workplace },
    });
  };

  const onCancel = () => {
    setShowPopUp(false);
    setPopUpMessage({});
  };

  const onOk = () => {
    setShowPopUp(false);
    setOpen(true);
    let msgErrorID = subscribeData?.onekeyEid;
    api
      .subscribeProfile(subscribeData)
      .then((res) => {
        if (res.data.eph_profile_flag == true) {
          var reference_Id = res?.data?.ReferenceId;

          setOpen(false);
          let translationKey = 'profileAlreadyExists'
          if (vendor == "Veeva Network") {
            translationKey = 'profileAlreadyExists_VN'
          }
          setPopUpMessage({
            heading: popMsg[0][translationKey].heading,
            message: popMsg[0][translationKey].description.replace(/{{msgErrorID}}/g, msgErrorID).replace(/{{reference_Id}}/g, reference_Id),
            cancel: "Close",
          });
          setShowPopUp(true);
        } else {
          // let isShellProfileCreated = res?.data?.ShellProfileStatus;
          let shellProfileInfo =  res?.data?.ShellProfileCreationMessage;
          setEntity(subscribeData?.onekeyEid);
          let translationKey = 'subscribeSuccess'
          if (vendor == "Veeva Network") {
            translationKey = 'subscribeSuccess_VN'
          }
          let responseMsg = popMsg[0][translationKey].description.replace(/{{msgErrorID}}/g, msgErrorID);
          if (vendor != "Veeva Network") {
            responseMsg += shellProfileInfo ? `\n\n${shellProfileInfo}` : '';
          }
          setPopUpMessage({
            heading: popMsg[0][translationKey].heading,
            message: responseMsg,
            cancel: "Close",
          });
          setOpen(false);
          setShowPopUp(true);
        }
      })
      .catch((error) => {
        setOpen(false);
        let translationKey = 'subscribeFailure'
        if (vendor == "Veeva Network") {
          translationKey = 'subscribeFailure_VN'
        }
        setPopUpMessage({
          heading: popMsg[0][translationKey].heading,
          message: popMsg[0][translationKey].description.replace(/{{msgErrorID}}/g, msgErrorID),
          cancel: "Close",
        });
        setShowPopUp(true);
      });
  };

  const createNewHCP = () => {
    history.push({
      pathname: "/new/hcp",
      state: {
        iqviaSource: true,
        country: location.state.seletedCountry,
        source: source,
        vendor: location.state.vendor,
        homePage_Lilly: false,
      },
    });
  };

  const createNewHCO = () => {
    history.push({
      pathname: "/new/hco",
      state: {
        iqviaSource: true,
        country: location.state.seletedCountry,
        homePage_Lilly: false, 
        user: location.state.user
      } 
    });
  };

  const findProp = (obj, prop, defval) => {
    if (typeof defval == "undefined") defval = null;
    prop = prop.split(".");
    for (var i = 0; i < prop.length; i++) {
      if (typeof obj[prop[i]] == "undefined" || typeof obj[prop[i]] == null) {
        return defval;
      }

      obj = obj[prop[i]];
    }
    if (obj == null) {
      defval = "";
      return defval;
    } else {
      return obj;
    }
  };

  const getRowArray = (res) => {
    let counter = 10;
    rowsArray.splice(0, rowsArray.length);
    res.length / 2 < counter && rowsArray.push(res.length);
    while (res.length / 2 > counter) {
      rowsArray.push(counter);
      counter += 10;
    }
    return rowsArray;
  };

  const handleChangeRowsPerPage = (event, sessionItems) => {
    setRowPerPage(event.target.value);
    setResponseData(sessionItems.slice(0, event.target.value));
  };
  const handleChangePage = (event, newPage, sessionItems) => {
    let startIndex = newPage * rowsPerPage;
    let endIndex = startIndex + rowsPerPage;

    if (endIndex > sessionItems.length) {
      endIndex = sessionItems.length;
    }

    setResponseData(sessionItems.slice(startIndex, endIndex));
    setPage(newPage);
    setRowPerPage(rowsPerPage);
  };

  const removeiqvafilter = () => {
    setsearchData([]);
    setResponseData([]);
    setNoRecords(false);
    setErrorMsg();

    setErrorAlert(false);
    setClear(true);
    let intervalId = setTimeout(() => {
      setClear(false);
      clearTimeout(intervalId);
    }, 1000);
  };

  const searchiqvia = () => {
    if (Object.keys(searchData).length > 0) {
      searchData["country"] = location.state.seletedCountry;
      searchData['entityType'] = hcoSearch ? 'HCO' : 'HCP'
      setLoading(true);

      api
        .getIqviaDetails("IqviaSearch", searchData)
        .then((res) => {
          if (res && res?.data && res?.data?.data && res?.data?.data?.length > 0) {
            // Removing objects if not having HCP(individual) data
            let filtredData
            if (location.state.seletedCountry == 'United States' && hcoSearch) {
              filtredData = res?.data?.data
            } else {
              filtredData = res?.data?.data.filter(item => item?.individual && Object.keys(item?.individual).length > 0)
            }            
            setResponseData(
              filtredData
                .map((data) => {
                    return {
                      ...data,
                      classificationcode: (data?.individual?.typeCorporateLabel?data?.individual?.typeCorporateLabel:data?.individual?.typeLabel?data?.individual?.typeLabel:'') + " (" + data?.individual?.typeCode + ")",
                    };
                })
                .slice(0, rowsPerPage)
            );
            setLoading(false);
            setsessionAllItems(
              filtredData.map((data) => {
                return {
                  ...data,
                  classificationcode: (data?.individual?.typeCorporateLabel?data?.individual?.typeCorporateLabel:data?.individual?.typeLabel?data?.individual?.typeLabel:'') + " (" + data?.individual?.typeCode + ")",
                };
              })
            );
            setErrorAlert(false);
          } else {
            setLoading(false);
            setNoRecords(true);
            setsessionAllItems(false);
            setResponseData([]);
          }
        })
        .catch((error) => {
          let errorDetail = error;
          setErrorAlert(true);
          let msg = errorDetail.response ? errorDetail.response.data.errorCode : popMsg[0].failure.description;
          setErrorMsg(msg ? msg : popMsg[0].failure.description);
          setLoading(false);
          setsessionAllItems([]);
          setResponseData([]);
        });
    } else {
      setPopUpMessage({
        heading: popMsg[0].blankField.heading,
        message: popMsg[0].blankField.description,
        cancel: "Close",
      });
      setShowPopUp(true);
    }
  };

  const updateValue = (newValue, flag, attribute) => {
    if (newValue.value.length == 0) {
      delete searchData[attribute];
    } else if (newValue.value.length > 0) {
      if (attribute == "primarySpecialty") {
        let spec = newValue.value.split("|");
        spec = spec[spec.length - 1].split(".");
        setsearchData({ ...searchData, [attribute]: spec[spec.length - 1] });
      } else {
        setsearchData({ ...searchData, [attribute]: newValue.value });
      }
    }
  };

  const goBack = () => {
    props.history.push("/");
  };

  const setHCOViewSearch = () => {
    setsearchData([])
    setResponseData([])
    // @todo change vendor for US
    setVendor(!hcoSearch ? 'IQVIA' : 'Veeva Network')
    setHcoSearch(!hcoSearch)
  }

  let formFields = countrydata.input[vendor.toLowerCase()]
  // for IQVIA_US, data strcutre is different, i.e. by country by source by entity type
  /*
    "country_Name": "United States",
    "country_Code": "US",
    "input": {
      "veeva network": {
        "HCP": [
          fields here
        ]
      }
  */
  if (location.state.seletedCountry == "United States") {
    formFields = (hcoSearch ? countrydata.input[vendor.toLowerCase()].HCO : countrydata.input[vendor.toLowerCase()].HCP)
  }

  const handleCopyClipboard = (event, data) => {
    event.stopPropagation();
    navigator.clipboard.writeText(data)
    setIsCopied(data)
    setTimeout(() => setIsCopied(null), 1000);
  }  

  return (
    <div className="extra-margin-top-less container body-height col-md-9 col-9 col-sm-12">
      {showForm && (
        <>
          <Stack
            direction={'row'}
            sx={{ justifyContent: 'space-between', alignItems: 'flex-start' }}
          >
            <Tooltip disableFocusListener title='Back' id='tooltip'>
              <IconButton
                aria-label='back'
                onClick={goBack}
                className='text-danger float-start'
                color='secondary'
              >
                <ArrowBackIcon
                  sx={{ transform: direction === 'rtl' ? 'rotate(180deg)' : '' }}
                />
              </IconButton>
            </Tooltip>
            {location.state.seletedCountry == "United States" &&
              <>
                <Typography>HCP <span>
                  <Switch checked={hcoSearch} onChange={() => setHCOViewSearch()} />
                </span>
                  HCO
                </Typography>
              </>
            }
          </Stack>

          <div className="row container iqaform">
            <Typography className="mb-5 _wg-dynamic-text" variant="h1" style={{ fontSize: 28 }} >
             
              <center>
                Search in Vendor <span className="_wg-exclude"> {location.state.seletedCountry != 'United States' ? `(${location.state.vendor})` : (hcoSearch ? '(HCO)' : '(HCP)')}</span> - <span id="vendor-country">{location.state.seletedCountry}</span>
              </center>{" "}
            </Typography>

            {formFields.map((value, key) => {
              return (
                <div className="col-sm-12 col-md-6 mt-3" key={key}>
                  <span className={`${value.name === 'License ID'?'_wg-exclude':''} _wg-dynamic-text`}>
                    {value.name}
                    {value.required ? "*" : ""}
                  </span>
                  <InputDetail
                    clear={clear}
                    date={false}
                    type={value.type}
                    value={value?.value ?? null}
                    options={value.options}
                    vendor={vendor} // used within InputDetail to determine where to fetch the Specialty from
                    label={value.name}
                    updatedValue={(newValue, flag) => {
                      updateValue(newValue, flag, value.id);
                    }}
                    entity={hcoSearch ? 'HCO' : 'HCP'}
                  />
                </div>
              );
            })}
          </div>

          <DialogActions sx={{ float: "left", mt: "10px" }} className="_wg-dynamic-text">
            <Button
              sx={{ float: "left" }}
              onClick={() => {
                if (hcoSearch) {
                  createNewHCO();
                } else {
                  createNewHCP()
                }
              }}
              color="error"
              variant="contained"
              autoFocus
            >
              {hcoSearch ? 'Create New HCO' : 'Create New HCP'}
            </Button>
          </DialogActions>
          <DialogActions sx={{ float: "right", mr: "20px", mt: "10px" }}>
            <Button
              className="_wg-dynamic-text"
              onClick={() => {
                removeiqvafilter();
              }}
              color="error"
              variant="outlined"
              autoFocus
            >
              Clear Filter
            </Button>

            <Button
              className="_wg-dynamic-text"
              onClick={() => {
                searchiqvia();
              }}
              color="error"
              variant="contained"
              autoFocus
            >
              Search
            </Button>
          </DialogActions>
        </>
      )}

      {loading && (
        <div className={Object.keys(searchData).length > 0 ? "d-flex justify-content-center mb-5" : "d-flex justify-content-center extra-margin-top mb-5"}>
          <ProgressBar />
        </div>
      )}

      {showPopUp && (
        <div>
          <Dialog open={true} aria-labelledby="customized-dialog-title">
            <DialogTitle className="_wg-dynamic-text">{popUpMessage.heading}</DialogTitle>

            {popUpMessage.message && (
              <DialogContent dividers>
                <Typography className="_wg-dynamic-text" gutterBottom>
                  {formatPopupMessage(popUpMessage.message, direction)}
                </Typography>
              </DialogContent>
            )}

            <DialogActions sx={{ mr: "15px" }}>
              {popUpMessage.cancel && (
                <Button onClick={onCancel} className="_wg-dynamic-text" color="error" variant="outlined" autoFocus>
                  {popUpMessage.cancel}
                </Button>
              )}
              {popUpMessage.onOk && (
                <Button onClick={onOk} className="_wg-dynamic-text" color="error" variant="contained" autoFocus>
                  {popUpMessage.onOk}
                </Button>
              )}
            </DialogActions>
          </Dialog>
        </div>
      )}

      {
        <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open}>
          {" "}
          <ProgressBar />{" "}
        </Backdrop>
      }
      {noRecords && !loading && !sessionAllItems && (
        <>
          <div className="container d-flex justify-content-center">
            <Alert severity="success" className="w-50 justify-content-center text-center _wg-dynamic-text" color="info">
              <strong>0</strong> Records in Vendor.{" "}
              {
                hcoSearch
                  ? <Link
                    to={{ 
                      pathname: '/new/hco', 
                      state: { 
                        iqviaSource:true, 
                        country: location.state.seletedCountry, 
                        homePage_Lilly: false, user: location.state.user } }}
                  >
                    {" "}
                    Add New HCO
                  </Link>
                  :
                  <Link
                    to={{
                      pathname: "/new/hcp",
                      state: {
                        iqviaSource: true,
                        country: location.state.seletedCountry,
                        homePage_Lilly: false,
                        source: source
                      },
                    }}
                  >
                    {" "}
                    Add New HCP
                  </Link>
              }
            </Alert>
          </div>
        </>
      )}

      {errorMsg !== undefined && errorAlert && <ErrorPage message={errorMsg} />}

      {!hcoSearch && 
      <div className="container col-md-12 pb-5" style={{ marginTop: "10%" }}>
        {responseData && responseData?.length > 0 &&  
          responseData.map((row, index) => {
            const accordianKey = `${row?.individual?.individualEid}_${index}`;
            return ( 
              <Accordion className="resultaccordian" key={accordianKey} expanded={expanded[accordianKey] || false} onChange={handleChange(accordianKey)}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header" style={{ background: "white" }}>
                  <table>
                    <tbody>
                      <tr>
                        <td style={{ width: "60px" }}>
                          <Avatar>
                            <ProfileIcon
                                type='HCP'
                                iconSX={{
                                  width: '25px',
                                  height:'25px'
                                }}
                              />
                          </Avatar>
                        </td>
                        <td style={{ width: "300px" }}>
                          {row?.individual?.firstName} {row?.individual?.lastName}
                        </td>
                        <td style={{ width: "30rem" }}>
                          <Typography className="_wg-dynamic-text">
                            <span dir={direction} className="text-muted _wg-exclude"> {vendor == "Veeva Network" ? "VN ID" : "OneKey Id"}: </span>
                            <span dir={direction} className="_wg-exclude"> {row?.individual?.individualEid}</span>
                            {
                              row?.individual?.individualEid &&
                                <Tooltip title={isCopied && isCopied === row?.individual?.individualEid ? "Copied!" : "Click to Copy"}>
                                  <IconButton size="small" aria-label="copy" color="primary" onClick={(e)=> handleCopyClipboard(e, row?.individual?.individualEid)}>
                                    {isCopied && isCopied === row?.individual?.individualEid ? <Done fontSize="10px"/> : <ContentCopy fontSize={'10px'}/>}
                                  </IconButton>
                                </Tooltip>
                            }
                          </Typography>
                        </td>
                        <td>
                          {" "}
                          <Tooltip disableFocusListener title="Subscribe" id="tooltip">
                            <IconButton aria-label="delete " className=" MuiIconButton-label" color="secondary" onClick={(event) => subcribeProfile(row, event)}>
                              <FileDownloadIcon className="text-muted" />
                            </IconButton>
                          </Tooltip>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </AccordionSummary>
                <AccordionDetails>
                  {IqviaCountryData.field_map.map((value, key) => {
                    const dataValue = findProp(row, value.from_Key, "");
                    return (
                      <div key={key}>
                        {typeof dataValue != "object" ? (
                          <Typography className="_wg-dynamic-text">
                          <span dir={direction} className={`text-muted ${value?.label_Name === 'HCP OneKey ID'? '_wg-exclude':''}`}> {value?.label_Name}: </span>
                          <span dir={direction} className="_wg-exclude">{dataValue}</span>
                            {
                              dataValue && value?.label_Name === 'HCP OneKey ID' &&
                              <Tooltip title={isCopied && isCopied === dataValue ? "Copied!" : "Click to Copy"}>
                                <IconButton size="small" aria-label="copy" color="primary" onClick={(e)=> handleCopyClipboard(e, dataValue)}>
                                  {isCopied && isCopied === dataValue ? <Done fontSize="10px"/> : <ContentCopy fontSize={'10px'}/>}
                                </IconButton>
                              </Tooltip>
                            }
                          </Typography>
                        ) : (
                          Object.values(dataValue).map((res, index) => {
                            const primary_address = Object.values(res?.address).filter((data) => data?.typeCodeCorporateLabel == "Primary address");
                            const other_address = Object.values(res?.address).filter((data) => data?.typeCodeCorporateLabel != "Primary address");
                            const nestedAccordian1Key = `${row?.individual?.individualEid}_${index}_nested1`;                          
                            return (
                              <>
                                <Card className="mt-3">
                                  <CardContent>
                                    <Typography className="_wg-dynamic-text">Workplace {index + 1}: </Typography>

                                    {res != undefined && (res?.managerWorkplaceUsualName || res?.usualName) && (
                                      <>
                                        <Accordion className="resultaccordian mt-2" key={nestedAccordian1Key} expanded={expanded[nestedAccordian1Key] || false} onChange={handleChange(nestedAccordian1Key)}>
                                          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header" sx={{ bgcolor: "#eeeeee" }}>
                                            <Typography className="_wg-dynamic-text">Details</Typography>
                                          </AccordionSummary>
                                          <AccordionDetails>
                                            <Typography className="_wg-dynamic-text">
                                            <span  dir={direction} className="text-muted _wg-exclude"> HCO OneKey ID: </span>
                                            <span dir={direction} className="_wg-exclude">{res?.managerWorkplaceEid}</span>
                                            </Typography>
                                            <Typography className="_wg-dynamic-text">
                                            <span className="text-muted">Name: </span>
                                            <span className="_wg-exclude">{res?.managerWorkplaceOfficialName}</span>
                                            </Typography>
                                            <Typography className="_wg-dynamic-text">
                                            <span className="text-muted">Name 2: </span>
                                            <span className="_wg-exclude">{res?.managerWorkplaceOfficialName2}</span>
                                            </Typography>
                                            <Typography className="_wg-dynamic-text">
                                            <span className="text-muted">Alternate Name: </span>
                                            <span className="_wg-exclude">{res?.managerWorkplaceUsualName}</span>
                                            </Typography>
                                            <Typography className="_wg-dynamic-text">
                                            <span className="text-muted">Alternate Name 2: </span>
                                            <span className="_wg-exclude">{res?.managerWorkplaceUsualName2}</span>
                                            </Typography>
                                            <Typography className="_wg-dynamic-text">
                                            <span dir={direction} className="text-muted _wg-exclude">HCO Department OneKey ID: </span>
                                            <span dir={direction} className="_wg-exclude">{res?.workplaceEid}</span>
                                            </Typography>
                                            <Typography className="_wg-dynamic-text">
                                            <span className="text-muted">HCO Department Name: </span>
                                            <span className="_wg-exclude">{res?.usualName}</span>
                                            </Typography>
                                            <Typography className="_wg-dynamic-text">
                                            <span className="text-muted">HCO Department Name 2: </span>
                                            <span className="_wg-exclude">{res?.usualName2}</span>
                                            </Typography>
                                          </AccordionDetails>
                                        </Accordion>
                                      </>
                                    )}

                                    
                                    {res?.speciality != undefined && res?.speciality && !!Object.values(res?.speciality).length && (
                                      <Accordion className="resultaccordian mt-2" key={nestedAccordian1Key + 1} expanded={expanded[nestedAccordian1Key + 1] || false} onChange={handleChange(nestedAccordian1Key + 1)}>
                                        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header" sx={{ bgcolor: "#eeeeee" }}>
                                          <Typography className="_wg-dynamic-text">Specialties</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                          {Object.values(res?.speciality).map((spec, index) => {
                                            const nestedAccordian2Key = `${row?.individual?.individualEid}_${index}_nested2`;                                           
                                            return (
                                              <List
                                                sx={{
                                                  width: "100%",
                                                  marginTop: 2,
                                                }}
                                                component="nav"
                                                aria-labelledby="nested-list-subheader"
                                                className={classes.root}
                                                key={nestedAccordian2Key}
                                              >
                                                <ListItemButton
                                                  onClick={() => handleClick(spec?.code)}
                                                  sx={{
                                                    bgcolor: "#eeeeee",
                                                  }}
                                                  id="list-address"
                                                  key={nestedAccordian2Key}
                                                >
                                                  <ListItemText>
                                                    <Typography>{spec?.corporateLabel ?? spec?.codeCorporateLabel}</Typography>
                                                  </ListItemText>
                                                  {expanded[spec?.code] ? <RemoveIcon /> : <AddIcon />}
                                                </ListItemButton>
                                                <Collapse in={expanded[spec?.code]} timeout="auto" unmountOnExit>
                                                  <List component="div" disablePadding>
                                                    <ListItemButton sx={{ pl: 4 }} id="list-detail">
                                                      <ListItemText>
                                                        <Typography className="_wg-dynamic-text">
                                                        <span className="text-muted">Speciality: </span>
                                                        <span className="_wg-exclude">{spec?.corporateLabel ?? spec?.codeCorporateLabel}</span>
                                                        </Typography>
                                                        <Typography className="_wg-dynamic-text">
                                                        <span className="text-muted">Rank: </span>
                                                        <span className="_wg-exclude">{spec?.rank}</span>
                                                        </Typography>
                                                        {spec.code &&
                                                          <Typography className="_wg-dynamic-text">
                                                            <span className="text-muted">Code: </span>
                                                            <span className="_wg-exclude">{spec.code}</span>
                                                          </Typography>}
                                                      </ListItemText>
                                                    </ListItemButton>
                                                  </List>
                                                </Collapse>
                                              </List>
                                            );
                                          })}
                                        </AccordionDetails>
                                      </Accordion>
                                    )}

                                    {res?.speciality == undefined && (
                                      <Accordion className="resultaccordian mt-2" key={nestedAccordian1Key + 2} expanded={expanded[nestedAccordian1Key + 2] || false} onChange={handleChange(nestedAccordian1Key + 2)}>
                                        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header" sx={{ bgcolor: "#eeeeee" }}>
                                          <Typography className="_wg-dynamic-text">Specialties</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                          <List sx={{ width: "100%", marginTop: 2 }} component="nav" aria-labelledby="nested-list-subheader" className={classes.root} key={nestedAccordian1Key +3 }>
                                            <ListItemButton onClick={() => handleClick(nestedAccordian1Key + 3)} sx={{ bgcolor: "#eeeeee" }} id="list-address" key={nestedAccordian1Key + 3}>
                                              <ListItemText>
                                                <Typography className="_wg-dynamic-text">Speciality</Typography>
                                              </ListItemText>
                                              {expanded[nestedAccordian1Key + 3] ? <RemoveIcon /> : <AddIcon />}
                                            </ListItemButton>
                                            <Collapse in={expanded[nestedAccordian1Key + 3]} timeout="auto" unmountOnExit>
                                              <List component="div" disablePadding>
                                                <ListItemButton sx={{ pl: 4 }} id="list-detail">
                                                  <ListItemText>
                                                    <Typography className="text-muted _wg-dynamic-text">Speciality:</Typography>
                                                    <Typography className="text-muted _wg-dynamic-text">Rank:</Typography>
                                                  </ListItemText>
                                                </ListItemButton>
                                              </List>
                                            </Collapse>
                                          </List>
                                        </AccordionDetails>
                                      </Accordion>
                                    )}


                                    {res?.address != undefined && res?.address && (primary_address.length > 0 || other_address.length > 0) && (
                                      <Accordion className="resultaccordian mt-2" key={nestedAccordian1Key + 4} expanded={expanded[nestedAccordian1Key + 4] || false} onChange={handleChange(nestedAccordian1Key + 4)}>
                                        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header" sx={{ bgcolor: "#eeeeee" }}>
                                          <Typography className="_wg-dynamic-text">Address</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                          {primary_address?.length > 0 && (
                                            <Typography className="mt-2 _wg-dynamic-text">
                                              Primary Address:
                                            </Typography>
                                          )}

                                          {Object.values(primary_address).map((add, index) => {
                                             const nestedAccordian3Key = `${row?.individual?.individualEid}_${index}_nested3`;
                                            return (
                                              <List
                                                sx={{
                                                  width: "100%",
                                                  marginTop: 2,
                                                }}
                                                component="nav"
                                                aria-labelledby="nested-list-subheader"
                                                className={classes.root}
                                                key={nestedAccordian3Key}
                                              >
                                                <ListItemButton
                                                  onClick={() => handleClick(add?.address?.addressLongLabel)}
                                                  sx={{
                                                    bgcolor: "#eeeeee",
                                                  }}
                                                  id="list-address"
                                                  key={nestedAccordian3Key}
                                                >
                                                  <ListItemText>
                                                    <Typography>
                                                      {add?.address?.addressLongLabel}, {add?.address?.postalTownReference?.villageLabel}
                                                    </Typography>
                                                  </ListItemText>
                                                  {expanded[add?.address?.addressLongLabel] ? <RemoveIcon /> : <AddIcon />}
                                                </ListItemButton>
                                                <Collapse in={expanded[add?.address?.addressLongLabel] || false} timeout="auto">
                                                  <List component="div" disablePadding>
                                                    <ListItemButton sx={{ pl: 4 }} id="list-detail">
                                                      <ListItemText>
                                                        <Typography className="_wg-dynamic-text">
                                                        <span className="text-muted">Address Line 1: </span>
                                                        <span className="_wg-exclude">{add?.address?.addressLongLabel}</span>
                                                        </Typography>
                                                        <Typography className="_wg-dynamic-text">
                                                        <span className="text-muted">Address Line 2: </span>
                                                        <span className="_wg-exclude">{add?.address?.addressLongLabel2}</span>
                                                        </Typography>
                                                        <Typography className="_wg-dynamic-text">
                                                        <span className="text-muted">City: </span>
                                                        <span className="_wg-exclude">{add?.address?.postalTownReference?.villageLabel}</span>
                                                        </Typography>
                                                        <Typography className="_wg-dynamic-text">
                                                        <span className="text-muted">City 2: </span>
                                                        <span className="_wg-exclude">{add?.address?.postalTownReference?.villageLabel2}</span>
                                                        </Typography>
                                                        <Typography className="_wg-dynamic-text">
                                                        <span  className="text-muted">Country: </span>
                                                        <span className="_wg-exclude">{add?.address?.postalTownReference?.country}</span>
                                                        </Typography>
                                                        <Typography className="_wg-dynamic-text">
                                                        <span className="text-muted">Rank: </span>
                                                        <span className="_wg-exclude">{add?.rank}</span>
                                                        </Typography>
                                                        <Typography className="_wg-dynamic-text">
                                                        <span className="text-muted">Type: </span>
                                                        <span className="_wg-exclude">{add?.typeCodeCorporateLabel} ({add?.typeCode})</span>
                                                        </Typography>
                                                      </ListItemText>
                                                    </ListItemButton>
                                                  </List>
                                                </Collapse>
                                              </List>
                                            );
                                          })}

                                          {other_address?.length > 0 && (
                                            <Typography className="mt-2 _wg-dynamic-text">
                                              Other Address:
                                            </Typography>
                                          )}

                                          {Object.values(other_address).map((add, index) => {
                                            const nestedAccordian4Key = `${row?.individual?.individualEid}_${index}_nested4`;
                                            return (
                                              <List
                                                sx={{
                                                  width: "100%",
                                                  marginTop: 2,
                                                }}
                                                component="nav"
                                                aria-labelledby="nested-list-subheader"
                                                className={classes.root}
                                                key={nestedAccordian4Key}
                                              >
                                                <ListItemButton
                                                  onClick={() => handleClick(add?.address?.addressLongLabel)}
                                                  sx={{
                                                    bgcolor: "#eeeeee",
                                                  }}
                                                  id="list-address"
                                                  key={nestedAccordian4Key}
                                                >
                                                  <ListItemText>
                                                    <Typography>
                                                      {add?.address?.addressLongLabel}, {add?.address?.postalTownReference?.villageLabel}
                                                    </Typography>
                                                  </ListItemText>
                                                  {expanded[add?.address?.addressLongLabel] ? <RemoveIcon /> : <AddIcon />}
                                                </ListItemButton>
                                                <Collapse in={expanded[add?.address?.addressLongLabel] || false} timeout="auto">
                                                  <List component="div" disablePadding>
                                                    <ListItemButton sx={{ pl: 4 }} id="list-detail">
                                                      <ListItemText>
                                                        <Typography className="_wg-dynamic-text">
                                                        <span className="text-muted">Address Long Label: </span>
                                                        <span className="_wg-exclude">{add?.address?.addressLongLabel}</span>
                                                        </Typography>
                                                        <Typography className="_wg-dynamic-text">
                                                        <span className="text-muted">Address Long Label 2: </span>
                                                        <span className="_wg-exclude">{add?.address?.addressLongLabel2}</span>
                                                        </Typography>
                                                        <Typography className="_wg-dynamic-text">
                                                        <span className="text-muted">Village Label: </span>
                                                        <span className="_wg-exclude">{add?.address?.postalTownReference?.villageLabel}</span>
                                                        </Typography>
                                                        <Typography className="_wg-dynamic-text">
                                                        <span className="text-muted">Village Label 2: </span>
                                                        <span className="_wg-exclude">{add?.address?.postalTownReference?.villageLabel2}</span>
                                                        </Typography>
                                                        <Typography className="_wg-dynamic-text">
                                                        <span  className="text-muted">Country: </span>
                                                        <span className="_wg-exclude">{add?.address?.postalTownReference?.country}</span>
                                                        </Typography>
                                                        <Typography className="_wg-dynamic-text">
                                                        <span className="text-muted">Rank: </span>
                                                        <span className="_wg-exclude">{add?.rank}</span>
                                                        </Typography>
                                                        <Typography className="_wg-dynamic-text">
                                                        <span className="text-muted">Type: </span>
                                                        <span className="_wg-exclude">{add?.typeCodeCorporateLabel}({add?.typeCode}) </span>
                                                        </Typography>
                                                      </ListItemText>
                                                    </ListItemButton>
                                                  </List>
                                                </Collapse>
                                              </List>
                                            );
                                          })}
                                        </AccordionDetails>
                                      </Accordion>
                                    )}
                                  </CardContent>
                                </Card>
                              </>
                            );
                          })
                        )}
                      </div>
                    );
                  })}
                </AccordionDetails>
              </Accordion>
            );
          })}

        {sessionAllItems.length !== 0 && responseData.length > 0 && 
        <TablePagination component="div" 
        count={sessionAllItems.length} 
        page={Page} className="_wg-dynamic-text" 
        onPageChange={(event, newPage) => handleChangePage(event, newPage, sessionAllItems)} 
        rowsPerPage={rowsPerPage} 
        onRowsPerPageChange={(event) => handleChangeRowsPerPage(event, sessionAllItems)} 
        rowsPerPageOptions={[10, 20, 30, 40, 50]} />}
      </div>
      }
      {location.state.seletedCountry == 'United States' && !loading && hcoSearch &&
        <div className="container col-md-12 pb-5" style={{ marginTop: '10%' }}>
          {/* parse IQVIA HCO vendor search response */}
          <IqviaHcoResponse vendor={vendor} data={responseData} />
        </div>
      }
    </div>
  );
};
export default IqviaSearch;